export default "__VITE_ASSET__Dg_RvwMX__"